var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.9124 0C7.62808 0 0.912354 6.71573 0.912354 15C0.912354 23.2843 7.62808 30 15.9124 30C24.1966 30 30.9124 23.2843 30.9124 15C30.9124 6.71573 24.1966 0 15.9124 0ZM17.4758 15.6589V23.8197H14.0993V15.6592H12.4124V12.8469H14.0993V11.1585C14.0993 8.86425 15.0518 7.5 17.7581 7.5H20.0112V10.3126H18.6028C17.5493 10.3126 17.4797 10.7056 17.4797 11.4391L17.4758 12.8466H20.0271L19.7286 15.6589H17.4758Z","fill":"black"}));
}

FacebookInline.defaultProps = {"width":"31","height":"30","viewBox":"0 0 31 30","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
